import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import PTMButton from "../PTMButton";

function BoilerplateDisplayerEntry(props) {
    const {
        insertHandler,
        description,
        content,
    } = props;

    const [displayPreview, setDisplayPreview] = useState(false);

    const StyledContainer = styled("div")(({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
        padding: "6px 16px",
        borderRadius: "4px",
        margin: "5px 0",
        display: "flex",
        justifyContent: "space-between",
        cursor: "pointer",
    }));

    const ActionsContainer = styled("div")(() => ({
        display: "flex",
        gap: 5,
    }));

    const PreviewContainer = styled("div")(({ theme }) => ({
        padding: 20,
        border: `1px solid ${theme.palette.grey.A700}`,
        borderRadius: "4px",
        cursor: "pointer",
        transition: "all .3s",
        "&:hover": {
            backgroundColor: theme.palette.info.main,
        },
    }));

    return (
        <div>
            <StyledContainer
                onClick={() => setDisplayPreview(!displayPreview)}
            >
                <div>
                    <p style={{ fontWeight: 600, margin: 0 }}>{description}</p>
                </div>
                <ActionsContainer>
                    <PTMButton
                        color="success"
                        variant="contained"
                        icon="copy"
                        popover="Einfügen"
                        onClick={(e) => {
                            insertHandler(content);
                            e.stopPropagation();
                        }}
                    />
                    <PTMButton
                        color="info"
                        variant="contained"
                        popover={`${displayPreview ? "Ein" : "Aus"}klappen`}
                        icon={`chevron-${displayPreview ? "up" : "down"}`}
                        onClick={() => setDisplayPreview(!displayPreview)}
                    />
                </ActionsContainer>
            </StyledContainer>
            { displayPreview
            && (
                <PreviewContainer
                    dangerouslySetInnerHTML={{ __html: content }}
                    onClick={() => insertHandler(content)}
                />
            )}
        </div>
    );
}

export default BoilerplateDisplayerEntry;
